import type {ConnectElementConfig} from '../ConnectElementList';

export const DebugCreateTestDataConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "debugCreateTestData" */
      '../../../components/DebugCreateTestData/DebugCreateTestData'
    ),
  teamOwner: 'connected-account-experiences-eng',
  sentryTeam: 'accounts_ui',
  enabledOverrideFlag: 'enable_debug_create_test_data',
  releaseState: 'internal',
  description: 'Create test payments, payouts, and risk interventions',
  friendlyName: 'Debug Create Test Data',
};
